import type { IconData } from '@stacksjs/iconify-core'

export const smokeSlash: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m384 316.118l32 32V240h-32zM440 240h32v120h-32zm-76.549-125.945a64.1 64.1 0 0 0-4.649 76.993L364.77 200h38.46l-17.8-26.7a31.98 31.98 0 0 1 2.32-38.418a63.745 63.745 0 0 0 3.479-78.69L385.377 48H348.8l-1.82 1.3l18.208 25.49a31.81 31.81 0 0 1-1.737 39.265m72 0a64.1 64.1 0 0 0-4.649 76.993L436.77 200h38.46l-17.8-26.7a31.98 31.98 0 0 1 2.32-38.418a63.745 63.745 0 0 0 3.479-78.69L457.377 48H420.8l-1.82 1.3l18.208 25.49a31.81 31.81 0 0 1-1.737 39.265M262.627 240l-224-224H16v22.627L217.373 240H16v120h321.373l136 136H496v-22.627ZM48 328v-56h201.373l56 56Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default smokeSlash
